import { useTickTruncation } from './hooks/useTickTruncation.js';
import { useYTickOffset } from './hooks/useYTickOffset.js';
import { TickWithTruncationForeignObject } from './TickWithTruncationForeignObject.js';
import type { TickRendererProps } from '../../../core/components/axes/types.js';
import { useXYChartTruncationMode } from '../../hooks/useXYChartTruncationMode.js';

interface YTickWithTruncationProps {
  position: 'left' | 'right';
  renderProps: TickRendererProps;
  maxSpaceForTruncation: number;
  centerTick: boolean;
  tickNameHasEmoji: boolean;
}

export function YTickWithTruncation({
  position,
  renderProps,
  maxSpaceForTruncation,
  centerTick,
  tickNameHasEmoji,
}: Readonly<YTickWithTruncationProps>) {
  const { formattedValue, x, y } = renderProps;

  const { truncationMode } = useXYChartTruncationMode();

  const {
    displayValue,
    tickClassName,
    tickInlineStyle,
    truncatedWidth,
    truncatedValue,
  } = useTickTruncation(formattedValue, maxSpaceForTruncation, truncationMode);

  const { xOffset, yOffset, style } = useYTickOffset(
    position,
    truncatedWidth,
    renderProps,
    centerTick,
    tickNameHasEmoji,
  );

  const showTooltip = truncatedValue === formattedValue;

  return (
    <TickWithTruncationForeignObject
      x={x - xOffset}
      y={y - yOffset}
      style={style}
      height={style.height as number}
      width={style.width as number}
      tickClassName={tickClassName}
      tickInlineStyle={tickInlineStyle}
      formattedValue={formattedValue as string}
      displayValue={displayValue}
      showTooltip={showTooltip}
    />
  );
}
